@if (active) {
  <div class="pl-spinner" style="z-index: 100;">
    <svg class="pl-spinner"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-spinner"></use></svg>
  </div>
}
